export enum SideBarStateEnum {
  Hidden = 1,
  Open = 2,
  Close = 3,
  Full = 4,
}
